var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentLinesLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4.5H1.5V19.5H3V4.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 3H4.5V21H6V3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 21V22.5H9V21H21ZM21 3H9V22.5C8.22334 22.5 7.58461 21.9097 7.50781 21.1533L7.5 21V3C7.5 2.17157 8.17157 1.5 9 1.5H21L21.1533 1.50781C21.9097 1.58461 22.5 2.22334 22.5 3V21L22.4922 21.1533C22.4205 21.8593 21.8593 22.4205 21.1533 22.4922L21 22.5V3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10.5H10.5V12H15V10.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 4.5H10.5V6H19.5V4.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 7.5H10.5V9H19.5V7.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentLinesLeft);
export default __webpack_public_path__ + "static/media/document-lines-left.c6374d37e217f3da7e0f927fc09c84e0.svg";
export { ForwardRef as ReactComponent };